module.exports = __webpack_public_path__ + "img/Meeting_record.f3b3808e.svg";